import DOMPurify from 'dompurify'

import { getCustomEmojiIndex } from '@/logic/emoji/customEmojis'

const customEmojiIndex = getCustomEmojiIndex()
const customEmojiIds = Object.keys(customEmojiIndex)

const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
const emojiPattern = customEmojiIds.length
  ? new RegExp(`:(${customEmojiIds.map(escapeRegex).join('|')}):`, 'g')
  : null

export function sanitizeText(t) {
  const clean = DOMPurify.sanitize(t, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })
  return clean.replace(/\n/g, '<br/>')
}

export function splitTextByCustomEmoji(text) {
  if (!emojiPattern) {
    return [{ type: 'text', content: sanitizeText(text) }]
  }

  const parts = []
  let lastIndex = 0
  text.replace(emojiPattern, (match, id, offset) => {
    if (offset > lastIndex) {
      parts.push({ type: 'text', content: sanitizeText(text.slice(lastIndex, offset)) })
    }
    const src = customEmojiIndex[id]?.skins?.[0]?.src
    if (src) {
      parts.push({ type: 'emoji', id, src })
    } else {
      parts.push({ type: 'text', content: sanitizeText(`:${id}:`) })
    }
    lastIndex = offset + match.length
    return match
  })
  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: sanitizeText(text.slice(lastIndex)) })
  }

  return parts
}

export function sanitizeMessageContent(content) {
  const sanitized = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ['span', 'br'],
    ALLOWED_ATTR: ['class'],
  })
  return sanitized.replace(/<br\s*\/?\s*>/gi, '\n')
}
